export default __webpack_public_path__ + "static/media/0xa0e390e9cea0d0e8cd40048ced9fa9ea10d71639.95264c1a.png";